import Collection from 'core/model/Collection';
import CloudExportTask from './CloudExportTask';

export default class CloudExportTaskCollection extends Collection {
  get url() {
    return '/api/ui/cloudExport';
  }

  get model() {
    return CloudExportTask;
  }

  get defaultSortState() {
    return {
      field: 'name',
      direction: 'asc'
    };
  }

  get presetGroups() {
    return [
      {
        name: 'cloud_provider',
        label: 'Provider',
        iconName: 'cloud'
      },
      {
        name: 'plan_id',
        label: 'Plan',
        iconName: 'card_membership',
        materialIcon: true
      },
      {
        name: 'enabled',
        label: 'Enabled',
        iconName: 'tick'
      }
    ];
  }

  getFilterValues(model) {
    return [
      'name',
      'properties.description',
      'cloud_provider',
      'properties.gce_project',
      'properties.gce_subscription',
      'properties.gcp_sampling_device_count',
      'properties.gcp_sampling_rate',
      'properties.gcp_metadata_only',
      'properties.aws_region',
      'properties.aws_bucket',
      'properties.aws_iam_role_arn'
    ].map((name) => model[name] || model.get(name));
  }
}
